// Google Tag Manager utility functions

// Extend Window interface to include dataLayer
declare global {
    interface Window {
        dataLayer: any[];
    }
}

// Type for GTM events
interface GTMEvent {
    event: string;
    [key: string]: any;
}

// Initialize the dataLayer array if it doesn't exist yet
export const initGTM = (): void => {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
};

// Push an event to the dataLayer
export const pushEvent = (event: GTMEvent): void => {
    if (!window.dataLayer) {
        initGTM();
    }
    window.dataLayer.push(event);
};

// Common events
export const pageView = (pagePath: string, pageTitle: string): void => {
    pushEvent({
        event: 'page_view',
        page_path: pagePath,
        page_title: pageTitle,
    });
};

export const buttonClick = (buttonName: string, buttonLocation: string): void => {
    pushEvent({
        event: 'button_click',
        button_name: buttonName,
        button_location: buttonLocation,
    });
};

export const formSubmit = (formName: string, formData?: Record<string, any>): void => {
    pushEvent({
        event: 'form_submit',
        form_name: formName,
        form_data: formData,
    });
};
